var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMastercard = function SvgMastercard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#34495E",
    fillRule: "evenodd",
    d: "M34 9.5H6c-1.1 0-2 .9-2 2v17c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2v-17c0-1.1-.9-2-2-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 20,
    r: 7,
    fill: "#E74C3C",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 7,
    fill: "#F1C40F",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74C3C",
    fillRule: "evenodd",
    d: "M21.8 16.5h-5.6c-.2.3-.4.6-.6 1h6.8c-.2-.4-.4-.7-.6-1zm-1.6-2h-2.3c-.3.3-.6.6-.9 1h4.2c-.4-.4-.8-.7-1-1zm2.6 4h-7.5c-.1.3-.2.7-.2 1H23c-.1-.3-.1-.7-.2-1zm-6.6 5h5.6c.2-.3.4-.6.6-1h-6.8c.2.4.4.7.6 1zm-1-2h7.5c.1-.3.2-.7.2-1H15c.1.3.1.7.2 1zm2.6 4h2.3c.3-.3.6-.6.9-1h-4.2c.4.4.8.7 1 1z",
    clipRule: "evenodd"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mastercard.e08c4ebdb16159c48289d574cc4df76f.svg";